import React from 'react';
import { Box } from '@mui/material';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import useStyles from './styles';
export const ScheduleChangeLayout = _ref => {
  let form = _ref.form,
    rail = _ref.rail,
    footerLeft = _ref.footerLeft,
    footerRight = _ref.footerRight;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles({});
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: classes.body
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.formColumn
  }, form), /*#__PURE__*/React.createElement(Box, {
    className: classes.railColumn
  }, rail)), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, footerLeft), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, footerRight)))));
};